export default "__VITE_ASSET__SsWOES3A__"